import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex flex-column align-items-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-exclamation-circle fa-2x mb-3 text-danger" }, null, -1)
const _hoisted_3 = {
  class: "fw-lighter",
  style: {"font-size":"smaller"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("button", {
      role: "button",
      class: "btn btn-outline-danger mb-3",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.requestRetry && _ctx.requestRetry(...args)))
    }, "Try Again"),
    _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.errorMessage), 1)
  ]))
}